import bookings from './Booking/reducers';
import locationReducer from './location/location-reducer';

export default { bookings, locationReducer };
